import { componentVariant } from '../../../internal/styles/componentVariant';
import type { Theme } from '../../../themes/types';

const typeVariant = ({ theme }: { theme: Theme }) => {
  return componentVariant({
    prop: 'variant',
    variants: {
      primary: {
        color: 'button.primary.color',
        bg: 'button.primary.bgColor',
        border: 'unset',

        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'button.primary.hover.bgColor',
            color: 'button.primary.hover.color',
          },
        },
        ':active': {
          bg: 'button.primary.active.bgColor',
        },
        ':focus': {},
        ':disabled': {
          bg: 'button.highlight.disabled.bgColor',
          color: 'button.highlight.disabled.color',
        },
      },
      secondary: {
        color: 'button.secondary.color',
        bg: 'button.secondary.bgColor',
        boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            bg: 'button.secondary.hover.bgColor',
            color: 'button.secondary.hover.color',
            boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
          },
        },
        ':active': {
          bg: 'button.secondary.hover.bgColor',
          color: 'button.secondary.hover.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.primary['50']}`,
        },
        ':disabled': {
          bg: 'button.secondary.disabled.bgColor',
          color: 'button.secondary.disabled.color',
          boxShadow: `inset 0 0 0 1.5px ${theme.colors.neutral['50']}`,
        },
      },
      /**
       * @deprecated
       * no text button on cobalt design system
       * */
      text: {
        color: 'button.text.color',
        bg: 'transparent',
        borderColor: 'transparent',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            color: 'button.text.hover.color',
            backgroundColor: 'button.text.hover.bgColor',
          },
        },
        ':active:not(:disabled)': {
          color: 'button.text.active.color',
          backgroundColor: 'button.text.active.bgColor',
        },
        ':disabled': {
          color: 'button.text.disabled.color',
        },
      },
      positive: {
        color: 'neutral.0',
        backgroundColor: 'button.positive.bgColor',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            backgroundColor: 'button.positive.hover.bgColor',
          },
        },
        ':active:not(:disabled)': {
          backgroundColor: 'button.positive.active.bgColor',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      warning: {
        color: 'neutral.0',
        backgroundColor: 'button.warning.bgColor',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            backgroundColor: 'button.warning.hover.bgColor',
          },
        },
        ':active:not(:disabled)': {
          backgroundColor: 'button.warning.active.bgColor',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      critical: {
        color: 'neutral.0',
        backgroundColor: 'button.critical.bgColor',
        '@media (hover: hover)': {
          ':hover:not(:disabled)': {
            backgroundColor: 'button.critical.hover.bgColor',
          },
        },
        ':active:not(:disabled)': {
          backgroundColor: 'button.critical.active.bgColor',
        },
        ':disabled': {
          backgroundColor: 'neutral.30',
          color: 'neutral.50',
        },
      },
      deal: {
        color: 'neutral.0',
        backgroundColor: 'deals.50',
      },
    },
  });
};

export default typeVariant;
